import { NgModule } from '@angular/core';
import { RouterModule, type Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  NoPermissionLayoutComponent,
  NoPermissionLayoutModule,
} from '@clean-code/shared/auth/ui-auth';
import { ProfileResolver } from '@clean-code/shared/auth/util-auth';
import { dashboardRoutes } from '@clean-code/shared/dashboard/dashboard/feature-dashboard-view';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { TailwindLayoutModule } from '@clean-code/shared/frontoffice/ui-layout';
import { LayoutComponent } from '@clean-code/shared/templates/ui-tailwind-full-width';
import {
  ticketRoutes,
  TicketSource,
} from '@clean-code/shared/tickets/feature-tickets';
import { limitReportRoute } from '@clean-code/user-limit/feature-user-limit-list';
import {
  statisticsOverviewListRoutes,
  statisticsOverviewRoutes,
} from '@frontoffice/statistics/feature-statistics-overview';
import { contractsListRoutes } from '@frontoffice/contracts/feature-contracts-list';

const routes: Routes = [
  {
    // Target of MsalGuard's loginFailedRoute; must stay outside the guard.
    path: 'login',
    loadChildren: () =>
      import('@clean-code/shared/auth/ui-azure').then(
        (mod) => mod.azureLoginRoutes,
      ),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [MsalGuard],
    resolve: {
      profile: ProfileResolver,
    },
    children: [
      {
        path: '',
        redirectTo: 'start',
        pathMatch: 'full',
      },
      {
        path: 'notfound',
        loadChildren: () =>
          import('@clean-code/shared/frontoffice/ui-layout').then(
            (mod) => mod.NotFoundModule,
          ),
      },
      {
        path: 'start',
        loadChildren: () =>
          import('@clean-code/shared/frontoffice/ui-start').then(
            (mod) => mod.StartModule,
          ),
      },
      {
        path: 'info',
        loadChildren: () =>
          import('@clean-code/shared/frontoffice/ui-layout').then(
            (mod) => mod.InfoModule,
          ),
      },
      {
        path: 'market',
        loadChildren: () =>
          import('@backoffice-frontend/market/feature-dashboard').then(
            (mod) => mod.MarketFeatureDashboardModule,
          ),
        data: { canEdit: false },
      },
      {
        path: 'wiki',
        loadChildren: () =>
          import('@backoffice-frontend/wiki/feature-readonly-list').then(
            (mod) => mod.WikiFeatureReadonlyListModule,
          ),
      },
      {
        path: 'spreads',
        loadChildren: () =>
          import('@clean-code/shared/frontoffice/ui-layout').then(
            (mod) => mod.SpreadsModule,
          ),
        data: {
          translate: 'individual-spreads',
        },
      },
      {
        path: 'limit-report',
        loadChildren: () =>
          import('@frontoffice/limit-report/ui-limit-report-list').then(
            (mod) => mod.LimitReportListModule,
          ),
      },
      limitReportRoute,
      {
        path: 'imprint',
        loadChildren: () =>
          import('@clean-code/shared/frontoffice/ui-layout').then(
            (mod) => mod.ImprintModule,
          ),
      },
      {
        path: 'disclaimer',
        loadChildren: () =>
          import('@clean-code/shared/frontoffice/ui-layout').then(
            (mod) => mod.DisclaimerModule,
          ),
      },
      {
        path: 'contact',
        loadChildren: () =>
          import('@clean-code/shared/frontoffice/ui-layout').then(
            (mod) => mod.ContactModule,
          ),
      },
      {
        path: 'kam',
        loadChildren: () =>
          import('@clean-code/shared/frontoffice/ui-layout').then(
            (mod) => mod.KamModule,
          ),
      },
      {
        path: 'team',
        loadChildren: () =>
          import('@clean-code/shared/frontoffice/ui-layout').then(
            (mod) => mod.TeamModule,
          ),
      },
      ...ticketRoutes(TicketSource.FrontOfficeInt),
      dashboardRoutes,
      contractsListRoutes,
      statisticsOverviewListRoutes,
      ...statisticsOverviewRoutes,
      // {
      //   path: 'dashboard',
      //   children: [
      //     {
      //       path: '',
      //       loadChildren: () =>
      //         import('./pages/dashboard/dashboard.module').then(
      //           (mod) => mod.DashboardModule
      //         ),
      //     },
      //   ],
      // },
    ],
  },
  {
    path: '',
    component: NoPermissionLayoutComponent,
    children: [
      //     {
      //       path: 'login',
      //       loadChildren: () =>
      //         import('./pages/login/login.module').then((mod) => mod.LoginModule),
      //     },
      {
        path: 'forbidden',
        loadChildren: () =>
          import('@clean-code/shared/auth/ui-auth').then(
            (mod) => mod.ForbiddenModule,
          ),
      },
      {
        path: 'access-expired',
        loadChildren: () =>
          import('@clean-code/shared/frontoffice/ui-layout').then(
            (mod) => mod.AccessExpiredModule,
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'notfound',
  },
];
// { path: '', redirectTo: 'contracts', pathMatch: 'full'},
// { path: 'contracts', component: ContractCardContainer }

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      paramsInheritanceStrategy: 'always',
      scrollPositionRestoration: 'enabled',
      // enableTracing: true,
    }),
    TailwindLayoutModule,
    NoPermissionLayoutModule,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
